import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";

//i18n
import { withTranslation } from "react-i18next";
import UserService from "Api/Services/UserService";

const NotificationDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const [notificationUnreadcount, setNotificationUnreadcount] = useState('');
  const [notificationList, setNotificationList] = useState([]);
  const [notificatiomarkallread, setNotificatiomarkallread] = useState(false);

  const [error, setError] = useState('');
  const imageUrl = process.env.REACT_APP_PROFILE_IMAGE_API_URL;

  useEffect(() => {
    getNotificationList();
  }, []);

  useEffect(() => {
    getNotificationUnreadcount();
  }, [notificatiomarkallread]);

  const getNotificationUnreadcount = async () => {
    try {
      let response = await UserService.NotificationUnreadCount().json();

      if (response.status) {
        setNotificationUnreadcount(response.count);
        return;
      } else {
        setError(response.message);
        return;
      }

    } catch (error) {
      setError('something went wrong');
      return;
    }
  };

  const getNotificationList = async () => {
    try {
      let response = await UserService.AllNotificationList().json();
      if (response.status) {
        const unreadnotification = response.data.filter(data => data.is_read == 0);
        setNotificationList(unreadnotification);
        return;
      } else {
        setError(response.message);
        return;
      }
    } catch (error) {
      setError('something went wrong');
      return;
    }
  };


  const getNotificationMarkallread = async () => {
    try {
      let responsedata = await UserService.NotificationMarkallread().json();
      if (responsedata.status) {
        setNotificatiomarkallread(responsedata.status);
        return;
      } else {
        setError(response.message);
        return;
      }
    }
    catch (error) {
      setError('something went wrong');
      return;
    }
  };

  const handleMarkAsAllRead = () => {
    if (notificationUnreadcount > 0) {
      getNotificationMarkallread();
    }
    setMenu(!menu);
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => handleMarkAsAllRead()}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          {notificationUnreadcount > 0 ?
            <i className="bx bx-bell bx-tada" />
            :
            <i className="bx bx-bell" />
          }
          {notificationUnreadcount > 0 &&
            <span className="badge bg-danger rounded-pill" >{notificationUnreadcount}</span>
          }
        </DropdownToggle>


        <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
          {notificationList.length > 0 &&
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0"> {props.t("Notifications")} </h6>
                </Col>
                <div className="col-auto">
                  <a href="/notifications-list" className="small">
                    {" "}
                    View All
                  </a>
                </div>
              </Row>
            </div>
          }



          {notificationList?.length > 0 ?
            <SimpleBar style={{ height: "230px" }}  >
              {notificationList?.map((data, index) => (
                <Link to="" className="text-reset notification-item" key={index}>
                  <div className="d-flex">
                    <img
                      src={imageUrl + '/' + data.user_image}
                      className="me-3 rounded-circle avatar-xs"
                      alt="user-pic"
                    />
                    <div className="flex-grow-1">
                      <h6 className="mt-0 mb-1">
                        {data.username ? data.username  : data.sent_by_name}
                      </h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-1">
                          {data.content}
                        </p>
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" />{" "}
                          {data.sent_at}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </SimpleBar>
            :
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0"> No Notification Found! </h6>
                </Col>
              </Row>
            </div>
          }

          {/* <div className="p-2 border-top d-grid">
            <Link className="btn btn-sm btn-link font-size-14 text-center" to="/notifications-list">
              <i className="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">{props.t("View More..")}</span>
            </Link>
          </div> */}
        </DropdownMenu>
      </Dropdown>
    </React.Fragment >
  );
};

export default withTranslation()(NotificationDropdown);

NotificationDropdown.propTypes = {
  t: PropTypes.any
};